<template>
  <div class="order-summary-container">
    <h2 class="mt-2">Gravsten: {{selectedGravestone.name}}</h2>
    <p>Stensort: <span>{{ selectedStonetype.name }}</span></p>
    <p>Ytbehandling: <span>{{ selectedSurfacetreatment }}</span></p>
    <p>Kantbehandling: <span>{{ selectedEdgetreatment }}</span></p>
    <p>Storlek: <span>Bredd: {{ selectedStonesize.width }} cm, Höjd: {{ selectedStonesize.height }} cm</span></p>
    <p>Teckensnitt: <span>{{ selectedFont.name }}</span></p>
    <p>Textutförande: <span>{{ selectedInscriptiondesign.name }}</span></p>
    <p v-if="selectedTextColor.name">Textfärg: <span>{{ selectedTextColor.name }}</span></p>
    <p v-if="decors.length">Dekor: <span>{{ decors }}</span></p>
    <p v-if="selectedDecorColor.name">Dekorfärg: <span>{{ selectedDecorColor.name }}</span></p>
    <p v-if="reserverows">Lämna rader till framtiden: <span>{{ reserverows }} rader</span></p>
    <p v-if="selectedAccessories.length || textPriceInclVat > 0" class="mt-1 font-size-1 bold">Tillägg:</p>
    <p v-if="textPriceInclVat > 0">Text över 40 tecken: <span>{{ formatPrice(textPriceInclVat) }} kr</span></p>
    <p
      v-for="(accessories, i) in selectedAccessories"
      :key="i"
    >
      {{ accessories.name }}: <span>{{ formatPrice((accessories.name == 'Blomlist' ? accessories.priceInclVat * percentageIncrease : accessories.priceInclVat )) }} kr</span>
    </p>


    <h2 class="mt-2">Totalt: {{formatPrice((gravestonePriceInclVat * percentageIncrease) + textPriceInclVat + accessoriesPriceInclVat)}} kr <span class="font-size-1">(Inkl moms)</span></h2>
  </div>
</template>
<script>

export default {
  props: {
    selectedGravestone: Object,
    selectedStonetype: Object,
    selectedSurfacetreatment: Object,
    selectedEdgetreatment: Object,
    selectedStonesize: Object,
    selectedTexts: Array,
    selectedFont: Object,
    selectedInscriptiondesign: Object,
    selectedDecorColor: Object,
    selectedTextColor: Object,
    selectedDecors: Array,
    reserverows: Number,
    selectedAccessories: Array,
    textPriceInclVat: Number,
    gravestonePriceInclVat: Number,
    percentageIncrease: Number
  },
  data () {
    return {
      decors: [],
      accessoriesPriceInclVat: 0
    }
  },
  watch: {
    selectedDecors: {
      handler () {
        this.formatDecors();
      },
      deep: true,
    },
    selectedAccessories: {
      handler () {
        this.setAccessoriesPrice();
      },
      deep: true,
    },
    percentageIncrease: {
      handler () {
        this.setAccessoriesPrice();
      },
      deep: true,
    }
  },
  mounted() {
    this.setAccessoriesPrice();
  },
  methods: {
    formatDecors() {
      let decorsDisplay = this.selectedDecors.map(function(decor) {
      return decor['display_name'];
      });

      this.decors = decorsDisplay.join(', ');
    },
    setAccessoriesPrice() {
      let total = 0;
      this.selectedAccessories.forEach((accessories) => {
        total = total + (accessories.name == 'Blomlist' ? parseInt(accessories.priceInclVat * this.percentageIncrease)  : parseInt(accessories.priceInclVat));
      });
      this.accessoriesPriceInclVat = total;
    },
    formatPrice(x) {
      return x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .order-summary-container span {
    font-style: italic;
  }
</style>
